import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "priceWithComma",
})
export class PriceWithCommaPipe implements PipeTransform {
  transform(value: any, showPricesWithComma?: boolean): any {
    if (!showPricesWithComma || value === null || value === undefined) {
      return value;
    }

    return value.toString().replace(/\./g, ",");
  }
}
